import { Avatar, Box, Flex } from '@chakra-ui/react';
import { FaNode } from 'react-icons/fa6';

import { Txt } from '@app/components/common';
import { StructureNode } from '@app/api/models/structure';

import { TxNodeItem } from '../types';



export const TxReportViewNode = ({
  data,
  index,
  parentIndex,
  isLastLevel,
  onItemClick,
  linkUp,
  linkDown,
  linkMore,
}: {
  data: TxNodeItem;
  index: number;
  parentIndex: number;
  linkUp?: number;
  linkDown?: boolean;
  linkMore?: boolean;
  isLastLevel: boolean;
  onItemClick: (item: TxNodeItem) => void;
}) => {
  return <>
    <Flex 
      ml={index * 24 + 'px'} 
      cursor={isLastLevel ? undefined : 'pointer'} alignItems='center' 
      flexDirection='row' 
      onClick={() => !isLastLevel && onItemClick(data)} 
      p={1}
      _hover={isLastLevel ? undefined : {
        backgroundColor: 'gray.200',
      }}
      borderRadius={4}
      position='relative'
    >
      {linkUp && <Box 
        mt={-42 + 'px'}
        ml={-1 - 24 * (index - parentIndex) + 16 + 'px'} 
        width={24 * (index - parentIndex) - 16 + 'px'} 
        height={10} 
        position="absolute"
        borderBottom={1}
        borderLeft={1}
        borderStyle='dashed'
        borderColor='blue.400'
        borderBottomStartRadius={8}
        zIndex={100}
      />}
      <Avatar name={data.level.name} size='sm' colorScheme='brand' />
      <Box color={isLastLevel ? 'black' : 'brand.500'} pl={2}>
        {data.title}
        <Txt color='gray.500'>{data.subtitle}</Txt>
      </Box>
      {linkDown && <Box 
        mt={54 + 'px'}
        ml={4 + 'px'} 
        width={12 + 'px'} 
        height={6} 
        position="absolute"
        borderRight={1}
        borderStyle='dashed'
        borderColor='blue.400'
        zIndex={100}
      />}
      {linkMore && <Box 
        mt={32 + 'px'}
        ml={-1 - 24 * (index - parentIndex) + 16 + 'px'} 
        width={24 * (index - parentIndex) - 16 + 'px'} 
        height={12} 
        position="absolute"
        borderLeft={1}
        borderStyle='dashed'
        borderColor='blue.400'
        zIndex={100}
      />}
    </Flex>
  </>;
};  


export const OrgStructureNoData = ({ index }: { index: number }) => {
  return <Flex 
    ml={index * 24 + 'px'} 
    alignItems='center' 
    flexDirection='row' 
    p={1}
    position='relative'
  >
    <Box 
      mt={-42 + 'px'}
      ml={-9 + 'px'} 
      width={8 + 'px'} 
      height={10} 
      position="absolute"
      borderBottom={1}
      borderLeft={1}
      borderStyle='dashed'
      borderColor='blue.400'
      borderBottomStartRadius={8}
      zIndex={100}
    />
    <Avatar size='sm' colorScheme='grey' name='' icon={<></>} opacity={0.5} />
    <Box pl={2}>
      <Txt color='gray.500'>[Нет данных]</Txt>
    </Box>
  </Flex>;
};